module.exports = __webpack_public_path__ + "img/serve1.196813e5.png";